'use client';

import { type FC } from 'react';
import { m, useReducedMotion } from 'motion/react';
import { twMerge } from 'tailwind-merge';
import { accentLineExpand } from '@/utils/animation/variants';

type TCardAccentLine = {
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
};

export const CardAccentLine: FC<TCardAccentLine> = ({ position = 'bottom', className }) => {
  const prefersReducedMotion = useReducedMotion();

  const positionClasses = {
    top: 'top-0 left-0 h-0.5 w-0',
    bottom: 'bottom-0 left-0 h-0.5 w-0',
    left: 'top-0 left-0 w-0.5 h-0',
    right: 'top-0 right-0 w-0.5 h-0',
  };

  const isHorizontal = position === 'top' || position === 'bottom';

  const variants = prefersReducedMotion
    ? undefined
    : {
        rest: isHorizontal ? { width: '0%' } : { height: '0%' },
        hover: isHorizontal
          ? { width: '100%', transition: { duration: 0.4, ease: [0.25, 0.1, 0.25, 1.0] } }
          : { height: '100%', transition: { duration: 0.4, ease: [0.25, 0.1, 0.25, 1.0] } },
      };

  return (
    <m.div
      variants={variants}
      className={twMerge('absolute bg-action', positionClasses[position], className)}
    />
  );
};
